// Transposição de acordes Mí Chamou — 100% por regras (determinística).
const SHARP = ["C", "C#", "D", "D#", "E", "F", "F#", "G", "G#", "A", "A#", "B"];
const FLAT = ["C", "Db", "D", "Eb", "E", "F", "Gb", "G", "Ab", "A", "Bb", "B"];
const FLAT_TO_SHARP = { Db: "C#", Eb: "D#", Gb: "F#", Ab: "G#", Bb: "A#", Cb: "B", Fb: "E", "E#": "F", "B#": "C" };
const FLAT_KEYS = new Set(["F", "Bb", "Eb", "Ab", "Db", "Gb", "Cb", "Dm", "Gm", "Cm", "Fm", "Bbm", "Ebm", "Abm"]);

const ALLOWED_QUAL = /^[mMajingdsuospºo°ø+\-0-9().,#b\u25B3\u0394]*$/;
const CHORD_RE = /^([A-G](?:#|b)?)([^/\s]*)(?:\/([A-G](?:#|b)?))?$/;

function noteIndex(n) {
  if (!n) return -1;
  if (FLAT_TO_SHARP[n]) n = FLAT_TO_SHARP[n];
  return SHARP.indexOf(n);
}
function indexNote(i, preferFlat) {
  i = ((i % 12) + 12) % 12;
  return preferFlat ? FLAT[i] : SHARP[i];
}

export function isChordToken(tok) {
  if (!tok) return false;
  const t = tok.replace(/^[|(]+|[|)]+$/g, "").trim();
  const m = t.match(CHORD_RE);
  if (!m) return false;
  return ALLOWED_QUAL.test(m[2] || "");
}

export function transposeChordToken(tok, steps, preferFlat) {
  const m = tok.match(CHORD_RE);
  if (!m) return tok;
  const root = m[1];
  const qual = m[2] || "";
  const bass = m[3];
  const ri = noteIndex(root);
  if (ri < 0) return tok;
  let out = indexNote(ri + steps, preferFlat) + qual;
  if (bass) {
    const bi = noteIndex(bass);
    out += "/" + (bi >= 0 ? indexNote(bi + steps, preferFlat) : bass);
  }
  return out;
}

// Transpõe uma linha de acordes preservando (aprox.) as colunas de início.
export function transposeChordLine(line, steps, preferFlat) {
  if (!line || steps === 0) return line;
  const re = /\S+/g;
  let m;
  let res = "";
  while ((m = re.exec(line))) {
    const tok = m[0];
    const start = m.index;
    const rep = isChordToken(tok) ? transposeChordToken(tok, steps, preferFlat) : tok;
    if (start > res.length) res += " ".repeat(start - res.length);
    else if (res.length > 0) res += " ";
    res += rep;
  }
  return res;
}

export function transposeKey(key, steps, preferFlat) {
  if (!key) return key;
  const m = key.trim().match(/^([A-G](?:#|b)?)(.*)$/);
  if (!m) return key;
  const ri = noteIndex(m[1]);
  if (ri < 0) return key;
  return indexNote(ri + steps, preferFlat) + (m[2] || "");
}

// preferência por bemol conforme o tom atual
export function preferFlatsFor(key) {
  if (!key) return false;
  const root = (key.trim().match(/^([A-G](?:#|b)?m?)/) || [])[1] || "";
  if (root.includes("b")) return true;
  return FLAT_KEYS.has(root) || FLAT_KEYS.has(root.replace("m", ""));
}

// Limpa artefatos de copiar/colar (HTML/bbcode) e a sequência exata "> em qualquer posição.
export function sanitizeChordText(s) {
  if (s == null) return s;
  let t = String(s);
  t = t.replace(/&amp;/g, "&").replace(/&nbsp;/g, " ").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&#39;/g, "'").replace(/&quot;/g, '"');
  t = t.replace(/<[^<>\n]{1,120}>/g, "");
  t = t.replace(/\[\/?(?:ch|tab|cifra|verse|chorus|intro|solo)\]/gi, "");
  t = t.replace(/">/g, "").replace(/'>/g, "");
  t = t.replace(/^[ \t]*>[ \t]?/gm, "");
  return t;
}

// ---- conversão texto <-> linhas estruturadas (editor de revisão) ----
export function linesToText(lines) {
  return (lines || []).map((l) => {
    if (l.kind === "annotation") return l.text || "";
    if (l.kind === "pair") return `${l.chords}\n${l.lyrics}`;
    return l.chords || l.lyrics || l.text || "";
  }).join("\n");
}

const _isChordLine = (s) => {
  const t = (s || "").trim().split(/\s+/).filter(Boolean);
  if (!t.length) return false;
  const c = t.filter(isChordToken);
  return c.length >= 1 && c.length / t.length >= 0.6;
};
const _isAnn = (s) => {
  const t = (s || "").trim();
  return !!t && t.length <= 40 && /^(\(?x?\s*\d{1,2}\s*x?\)?|parada|break|segura|vira|solo|final seco|diminui|crescendo|tutti)$/i.test(t);
};

export function textToLines(text) {
  const raw = (text || "").replace(/\r\n/g, "\n").split("\n");
  const out = [];
  let i = 0;
  while (i < raw.length) {
    const line = raw[i];
    if (!line.trim()) { i++; continue; }
    if (_isAnn(line)) { out.push({ kind: "annotation", chords: "", lyrics: "", text: line.trim() }); i++; continue; }
    if (_isChordLine(line)) {
      const nxt = raw[i + 1] || "";
      if (nxt.trim() && !_isChordLine(nxt) && !_isAnn(nxt)) { out.push({ kind: "pair", chords: line, lyrics: nxt, text: "" }); i += 2; continue; }
      out.push({ kind: "chords", chords: line, lyrics: "", text: "" }); i++; continue;
    }
    out.push({ kind: "lyrics", chords: "", lyrics: line, text: "" }); i++;
  }
  return out;
}
